export const theme = {
    colors: {},
};
